import React, { ChangeEvent, useCallback } from 'react';
import { IconPhoto } from '@groupelacentrale/contact-storybook/lib/icons';
import './PhotoInput.scss';

interface Props {
  max: number;
  currentNumber: number;
  onAdd: (files: FileList) => undefined | void;
}

export const PhotoInput: React.FC<Props> = ({ max, currentNumber, onAdd }) => {
  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.files) {
        onAdd(e.target.files);
      }
      // reset input value
      e.target.value = '';
    },
    [onAdd],
  );

  return (
    <label className={`photo-input ${currentNumber !== 0 ? 'no-padding' : ''}`}>
      <IconPhoto width={36} color="blue" />
      <span>
        <b>Ajouter des photos</b>&nbsp;({currentNumber}/{max})
      </span>
      <input type="file" multiple name="photos" disabled={currentNumber === max} accept="image/*" onChange={onChange} />
    </label>
  );
};
